import {Callout} from '@wandb/weave/components/Callout';
import {Icon, IconName} from '@wandb/weave/components/Icon';
import {TagColorName} from '@wandb/weave/components/Tag';
import React from 'react';
import {twMerge} from 'tailwind-merge';

export const SettingsMenuItem = ({
  dataTest,
  icon,
  color,
  title,
  description,
  onClick,
}: {
  dataTest: string;
  icon: IconName;
  color: TagColorName;
  title: string;
  description: string;
  onClick: () => void;
}) => {
  return (
    <button
      aria-label={`${title} settings`}
      role="menuitem"
      data-test={dataTest}
      type="button"
      onClick={onClick}
      className={twMerge(
        'gap-20 py-16 pl-24 pr-20',
        'flex items-center ',
        'hover:cursor-pointer hover:bg-moon-100',
        'text-left',
        'min-h-[6rem]',
        'border-b-[1px] border-solid border-moon-250'
      )}>
      <Callout color={color} icon={icon} size="x-small" />
      <div className="flex w-full flex-col">
        <h2 className={twMerge('text-base font-semibold leading-[24px]')}>
          {title}
        </h2>
        <p className={twMerge('text-base leading-[140%] text-moon-500')}>
          {description}
        </p>
      </div>
      <Icon
        name="chevron-next"
        className={twMerge('text-moon-500', 'shrink-0 p-0')}
      />
    </button>
  );
};
